export default {
    toggleLoading: (state, value) => {
        state.showLoading = value
    },
    errorModal: (state, value) => {
        state.errorModal = value
    },
    consentModal: (state, value) => {
        state.consentModal = value
    },
    clarifyModal: (state, value) => {
        state.clarifyModal = value
    },
    kvkkModal: (state, value) => {
        state.kvkkModal = value
    },
}